import React, { Component } from "react";
// Externals
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import { CircularProgress, LinearProgress } from "@material-ui/core";

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";

// Component styles
import _ from "lodash";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";

import TablePagination from "@material-ui/core/TablePagination";
import Avatar from "@material-ui/core/Avatar";
import { connect } from "react-redux";
import { fetchMyContacts } from "../../redux/actions/profileScreenActions";
import { fetchLicenses, changeUserLicense, clearLicensesInfo } from "../../redux/actions/subscriptionActions";
import { pushMessage } from "../../redux/actions/commonActions";
import { removeMessage } from "../../redux/actions/commonActions";
import InviteUser from "../../layouts/Dashboard/components/RightSidebar/InviteUserForm";
import ResendInvite from "./ResendInvite";
import UserRole from "./UserRole";
import { ADMINISTRATOR_ROLE_VALUE } from "./constants";
import AddIcon from '@material-ui/icons/Add';
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CountersInfo from "../Subscriptions/components/SubscriptionInfo/countersInfo";
import Authorization from "../Subscriptions/components/Subscription/authorization";
import Loader from "../../components/Loader";

const FORCE_CHANGE_PASSWORD_STATUS = "FORCE_CHANGE_PASSWORD";

const nowSec = () => {
  const tmpDate = new Date();
  const ts = Math.floor(tmpDate.getTime() / 1000);
  return ts;
};

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  toolbar: {
    margin: "4px"
  },
  smallAvatar: {
    width: 40,
    height: 40,
    margin: "auto"
  },
  buttonWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: 0,
    borderTop: `1px solid ${theme.palette.background.light}`
  },
  resendInviteButtonContainer: {
    color: theme.palette.text.veryLight
  }
});

let id = 0;
function createData(name, tenant, company, email, nickname, role, status, picture) {
  id += 1;
  return { id, name, tenant, company, email, nickname, role, status, picture };
}

const ProfileContacts = props => {
  const { classes, componentProps, updateState, changeUserLicense, usersProps } = props;
  const { myUsers, currentPage, limit } = componentProps;
  const handleChange = (id, oldValue) => e => {
    //console.log("Element change for id ", id);
    const x = componentProps.myUsers.find(x => x.id === id);
    if (x && oldValue !== e.target.value) {
      const newResources = { ...componentProps.usersResources };
      newResources[x.email].users = { [e.target.value]: { counterSum: 1 } };
      updateState({ usersResources: newResources });
      const data = {
        method: "change_user_license",
        params: { user: x.email, oldLicense: "xxx", newLicense: e.target.value }
      };
      changeUserLicense(data);
    }
  };

  // simple authorization, allow account owner to chanage user licenses
  const licensesReadOnly = (tenant, user) => {
    if (!usersProps.subscriptions.license) return true;
    return !Authorization.Check("license_manager");
  };

  const getUserLicenseSelect = row => {
    if (!componentProps.licensesAvailable) {
      return;
    }

    const tenantLicenses = [...componentProps.licensesAvailable];
    const userLicensesInfo = componentProps.usersResources[row.email];
    if (!userLicensesInfo) {
      return;
    }
    const userLicenses = [];
    _.map(userLicensesInfo.users, (counter, key) => {
      userLicenses.push(key);
    });
    const foundItem = tenantLicenses.find(x => {
      return x.key === userLicenses[0];
    });
    if (!foundItem) tenantLicenses.push({ key: userLicenses[0], value: userLicenses[0] });
    const userId = _.get(usersProps.cognitoUser, "attributes[email]", "user");
    const tenantId = _.get(usersProps.cognitoUser, "attributes[custom:tenant]", "tenant");

    const isReadOnly = licensesReadOnly(tenantId, userId);

    let interactionsProgress = "";
    if (userLicenses[0] === "starter") {
      let percent = 0;
      let linearColor = "primary";
      if (
        userLicensesInfo &&
        userLicensesInfo.interactions &&
        userLicensesInfo.interactions.starter &&
        userLicensesInfo.interactions.starter.counterSum
      ) {
        percent = userLicensesInfo.interactions.starter.counterSum;
        if (percent > 90) linearColor = "secondary";
      }
      interactionsProgress = <LinearProgress variant="determinate" value={percent} color={linearColor} />;
    }

    return (
      <div style={{ display: "inline-block", justifyContent: "center", alignItems: "center" }}>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={userLicenses[0]}
          onChange={handleChange(row.id, userLicenses[0])}
          disabled={isReadOnly}
        >
          {tenantLicenses.map(x => {
            return (
              <MenuItem value={x.value} key={x.key}>
                {x.key}
              </MenuItem>
            );
          })}
        </Select>
        {interactionsProgress}
      </div>
    );
  };

  /**
   * For users with status "FORCE_CHANGE_PASSWORD" show the status "INVITED" and the button for resending the invite.
   */
  const renderUserStatus = (status, email, currentUserRole) => {
    if (status !== FORCE_CHANGE_PASSWORD_STATUS) {
      return status;
    }

    return (
      <span className={classes.resendInviteButtonContainer}>
        INVITED <ResendInvite userEmail={email} disabled={currentUserRole !== ADMINISTRATOR_ROLE_VALUE} />
      </span>
    );
  };

  const currentUserRole = _.get(usersProps.cognitoUser, "attributes[custom:role]", undefined);
  return (
    <div style={{ overflowY: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" />
            <TableCell>NAME</TableCell>
            <TableCell>EMAIL</TableCell>
            <TableCell>COMPANY</TableCell>
            <TableCell>USER LICENSE</TableCell>
            <TableCell>NICKNAME</TableCell>
            <TableCell>ROLE</TableCell>
            <TableCell>STATUS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {myUsers &&
            myUsers.map(row => (
              <TableRow key={row.id}>
                <TableCell padding="checkbox">
                  <Avatar alt={row.name} src={row.picture} className={classes.smallAvatar} />
                </TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.company}</TableCell>
                <TableCell>
                  <FormControl className={classes.margin}>
                    <InputLabel id="demo-customized-select-label" />
                    {getUserLicenseSelect(row)}
                  </FormControl>
                </TableCell>
                <TableCell>{row.nickname}</TableCell>
                <TableCell>
                  <UserRole
                    role={row.role}
                    userEmail={row.email}
                    disabled={currentUserRole !== ADMINISTRATOR_ROLE_VALUE}
                  />
                </TableCell>
                <TableCell>{renderUserStatus(row.status, row.email, currentUserRole)}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
};

class Users extends Component {
  signal = true;

  state = {
    isLoading: true,
    myUsers: undefined,
    openDialog: false,
    currentPage: 0,
    limit: 5,
    totalUsers: 0
  };

  fetchLicenses() {
    const data = {
      method: "license_list",
      params: {}
    };
    this.props.fetchLicenses(data);
  }

  handleRowChange = e => {
    e.preventDefault();
    this.loadMoreUserData(0, e.target.value);
  };

  handlePaginationChange = (e, value) => {
    e.preventDefault();
    this.loadMoreUserData(value, this.state.limit);
  };

  async loadMoreUserData(currentPage, limit) {
    this.setState({
      isLoading: true,
      currentPage: currentPage,
      limit: limit,
    });
    await this.props.fetchMyContacts(currentPage * limit, limit);
    this.setState({ isLoading: false });
  }

  componentDidMount() {
    this.props.fetchMyContacts(0, this.state.limit);
    this.fetchLicenses();
    //console.log("Users componentDidMount");
    Authorization.SetRoles(_.get(this.props.cognitoUser.attributes, "custom:role", "user"));
  }

  componentDidUpdate(prevProps, prevState) {}

  clearLicenses() {
    this.props.clearLicensesInfo();
  }

  processLicenses(licenseData, myUsers) {
    const licenses = licenseData.licenses.Items;
    const resources = licenseData.resources.Items;

    // Counters by subscription
    let counters = [];
    _.map(licenses, item => {
      _.map(item.counters, (counter, counter_code) => {
        counters.push({
          plan_code: item.plan_code,
          code: counter_code,
          counterLimit: counter.counterLimit,
          limit: counter.limit,
          counter: counter.counter
        });
      });
    });

    const licenseSum = {};
    _.map(_.groupBy(counters, "code"), (objs, key) => {
      if (!licenseSum[key]) licenseSum[key] = {};
      _.map(_.groupBy(objs, "plan_code"), (objs2, key2) => {
        const sum1 = _.sumBy(objs2, "counterLimit");
        const sum2 = _.sumBy(objs2, "limit");
        const sum3 = _.sumBy(objs2, "counter");
        if (!licenseSum[key][key2]) licenseSum[key][key2] = { counterLimitSum: sum1, limitSum: sum2, counterSum: sum3 };
        else {
          licenseSum[key][key2].counterLimitSum += sum1;
          licenseSum[key][key2].limitSum += sum2;
          licenseSum[key][key2].counterSum += sum3;
        }
      });
    });

    // Create free license (if not created)
    if (!licenseSum.users) licenseSum.users = {};
    if (!licenseSum.users.starter) licenseSum.users.starter = { counterLimitSum: 25, limitSum: 25, counterSum: 0 };

    //console.log("State Licenses:", licenseSum);
    this.setState({ licenses: licenseSum });

    // resources sum
    const resourcesSum = {};
    _.map(licenseSum, (codes, key) => {
      _.map(codes, (x, key2) => {
        if (!resourcesSum[key]) {
          resourcesSum[key] = { [key2]: { counterSum: 0 } };
        } else {
          resourcesSum[key][key2] = { counterSum: 0 };
        }
      });
    });

    // Load resources
    _.map(resources, resource => {
      //console.log("Loading resource", resource.tenant, resource.user);
      _.map(resource.counters, (part1, code) => {
        _.map(part1, (counter, plan_code) => {
          //console.log("Loading resource counter", code, plan_code, counter);
          if (!resourcesSum[code]) resourcesSum[code] = {};
          if (!resourcesSum[code][plan_code]) resourcesSum[code][plan_code] = { counterSum: counter.counter };
          else {
            resourcesSum[code][plan_code].counterSum += counter.counter;
          }
        });
      });
    });
    this.setState({ resourcesSum: resourcesSum });
    //console.log("State Resources Sum:", resourcesSum);

    // resources by User
    const usersResources = {};
    _.map(resources, resource => {
      if (!usersResources[resource.user]) usersResources[resource.user] = {};
      _.map(resource.counters, (part1, code) => {
        _.map(part1, (counter, plan_code) => {
          let counterAdd = counter.counter;
          if (counter.reset === true && counter.resetAt !== undefined && counter.resetAt < nowSec()) {
            counterAdd = 0;
          }
          if (!usersResources[resource.user][code]) usersResources[resource.user][code] = {};
          if (!usersResources[resource.user][code][plan_code])
            usersResources[resource.user][code][plan_code] = { counterSum: counterAdd };
          else {
            usersResources[resource.user][code][plan_code].counterSum += counterAdd;
          }
        });
      });
    });

    // Assign unregistered users Free license
    //console.log("USERS", myUsers);
    const autoAssignCode = "users";
    const autoAssignPlanCode = "starter";

    if (!resourcesSum[autoAssignCode]) resourcesSum[autoAssignCode] = { [autoAssignPlanCode]: { counterSum: 0 } };

    if (!resourcesSum[autoAssignCode][autoAssignPlanCode])
      resourcesSum[autoAssignCode][autoAssignPlanCode] = { counterSum: 0 };

    if (!resourcesSum[autoAssignCode][autoAssignPlanCode].counterSum)
      resourcesSum[autoAssignCode][autoAssignPlanCode].counterSum = 0;

    _.map(myUsers, user => {
      if (!usersResources[user.email]) {
        usersResources[user.email] = { [autoAssignCode]: { [autoAssignPlanCode]: { counterSum: 1 } } };
        resourcesSum[autoAssignCode][autoAssignPlanCode].counterSum += 1;
      }
    });

    this.setState({ usersResources: usersResources });
    //console.log("State User Resources:", usersResources);

    // popis licenci za prikazati
    const showList = [];
    _.map(licenseSum.users, (lic, key) => {
      //console.log("KEY", key);
      //console.log("LIC", lic);
      let sumToCheck = lic.counterLimitSum;
      if (!sumToCheck) sumToCheck = lic.limitSum;

      if (sumToCheck > 0 && (!resourcesSum.users[key] || resourcesSum.users[key].counterSum < sumToCheck))
        showList.push({ key: key, value: key });
    });
    this.setState({ licensesAvailable: showList });
    //console.log("State Licenses Available:", showList);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    let myUsers = [];
    /*    if (this.state.myUsers) myUsers = this.state.myUsers; */

    if (nextProps.myUsers && nextProps.myUsers.Users) {
      nextProps.myUsers.Users.forEach(function(user) {
        let userData = {};
        user.Attributes.forEach(function(attr) {
          if (
            [
              "given_name",
              "family_name",
              "email",
              "custom:tenant",
              "custom:company_name",
              "nickname",
              "custom:role",
              "picture"
            ].indexOf(attr.Name) >= 0
          ) {
            userData[attr.Name] = attr.Value;
          }
        });
        myUsers.push(
          createData(
            _.get(userData, "given_name", "") + " " + _.get(userData, "family_name", ""),
            _.get(userData, "custom:tenant", ""),
            _.get(userData, "custom:company_name", ""),
            _.get(userData, "email", ""),
            _.get(userData, "nickname", ""),
            _.get(userData, "custom:role", ""),
            _.get(user, "UserStatus", ""),
            _.get(userData, "picture", "https://cdn.pixabay.com/photo/2016/04/01/11/25/avatar-1300331_960_720.png")
          )
        );
      });
      this.setState({ myUsers: myUsers, isLoading: false, totalUsers: nextProps.myUsers.TotalUsers });
    }

    //console.log("LOAD LICENSE INFO", nextProps.subscriptions.license !== undefined, myUsers.length);
    if (nextProps.subscriptions.license && myUsers.length > 0) {
      this.processLicenses(nextProps.subscriptions.license.license, myUsers);
    }
  }

  toggleInviteUser = e => {
    this.setState({
      openDialog: !this.state.openDialog
    });
  };

  changeUserLicense = params => {
    this.clearLicenses();
    this.props.changeUserLicense(params).then(result => {
      if (!result || result.error) {
        this.props.pushMessage({
          type: "error",
          message: "Unable to change User License.",
          preventDuplicate: true
        });
      } else {
        this.props.pushMessage({
          type: "success",
          message: "User License changed.",
          preventDuplicate: true
        });
      }

      // send result message
      this.fetchLicenses();
    });
  };

  updateState = changeState => {
    //console.log("State users", this.state.myUsers);
    if (changeState) {
      //console.log("CHANGE STATE", changeState);
      this.setState(changeState);
    }
    this.setState({ licenseChanged: true });
  };

  buyLicense = license => {
    return "/manage-subscriptions?plan=" + license;
  };

  render() {
    const { classes, code } = this.props;
    const { currentPage, limit, myUsers } = this.state;

    let usersRender;
    if (code == 200) {
      usersRender = (
        <ProfileContacts
          classes={classes}
          usersProps={this.props}
          componentProps={this.state}
          updateState={this.updateState}
          changeUserLicense={this.changeUserLicense}
        />
      );
    } else if (code == 404 || code == 403) {
      usersRender = (
        <Alert severity="error">
          <AlertTitle>Access token error</AlertTitle>
          Access token not valid.
        </Alert>
      );
    } else if (code == 500) {
      usersRender = (
        <Alert severity="error">
          <AlertTitle>Server error</AlertTitle>
          Internal error while loading users — <strong>please reload page to try again!</strong>
        </Alert>
      );
    }

    return (
      <DashboardLayout title="Users">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h3" component="h3">Manage Users</Typography>
            <Button variant="contained" color="primary" onClick={this.toggleInviteUser}>
                <AddIcon /> Invite User
            </Button>
          </Box>
          <br /><br />
        <Paper elevation={1}>
          <CountersInfo componentState={{ licenses: this.state.licenses, resourcesSum: this.state.resourcesSum }} />
          {usersRender}
          {_.get(this.props.cognitoUser, "attributes[custom:role]", "user") === "Administrator" && (
            <div className={classes.buttonWrapper}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15, 20]}
                component="div"
                count={this.state.totalUsers}
                rowsPerPage={limit}
                page={currentPage}
                onChangePage={this.handlePaginationChange}
                onChangeRowsPerPage={this.handleRowChange}
              />
            <InviteUser openDialog={this.state.openDialog} toggleRightSidebar={this.toggleInviteUser} />
            </div>
          )}
          {this.state.isLoading&&<LinearProgress color="secondary" style={{width:"100%"}} />}
          {!myUsers&&<Loader/>}
        </Paper>
        
      </DashboardLayout>
    );
  }
}

Users.propTypes = {
  classes: PropTypes.object.isRequired,
  pushMessage: PropTypes.func
};

function mapStateToProps(state) {
  return {
    message: state.common.message,
    cognitoUser: state.auth.cognitoUser,
    myUsers: state.profile.myUsers,
    code: state.profile.code,
    subscriptions: state.subscriptions ? state.subscriptions : {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        removeMessage,
        fetchMyContacts,
        fetchLicenses,
        clearLicensesInfo,
        changeUserLicense,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

Users = connect(
  mapStateToProps,
  mapDispatchToProps
)(Users);

export default withStyles(styles)(Users);
